import { usePrescriptionStore } from '@App/stores';
import { Features } from '@Config/Features';
import { Area } from '@Domain/model/area';
import { InsuranceType } from '@Framework/constants/InsuranceType';
import { Box, createStyles, makeStyles, Typography } from '@material-ui/core';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';
import { formatCurrency } from '@Ui/theme/helper/formatCurrency';
import React, { useEffect, useState } from 'react';

import Feature from '../../atoms/Feature';

/**
 * MedicationInfoProps
 */
export interface MedicationInfoProps {
  area: Area;
  name: string;
  rating: number;
  insuranceType?: InsuranceType;
}

const useStyles = makeStyles(() =>
  createStyles({
    priceColumn: {
      color: CORPORATE_COLORS.CONTENT_DARK_PRIMARY_LOW
    }
  })
);

const priceColumn = (provider: MedicationInfoProps) => {
  const [formattedPrice, setFormattedPrice] = useState<string>('');
  const { insuranceType } = provider;
  const indicationPrice = usePrescriptionStore(state => state.indicationPrice);
  const indication = usePrescriptionStore(state => state.indication);
  const noIndicationText = 'Ich habe keine spezielle Indikation';
  let price = '';

  useEffect(() => {
    async function setFormatCurrency() {
      const response = await formatCurrency({ currency: 'EUR', locale: 'de', price: indicationPrice || 0 });
      response && setFormattedPrice(response);
    }
    setFormatCurrency();
  }, [indicationPrice]);

  if (indicationPrice && indication !== noIndicationText) {
    price = formattedPrice;
  } else {
    price = '12.90 € - 24.00 €';
  }

  if (insuranceType == InsuranceType.PUBLIC) {
    return (
      <>
        <Box component="div">
          <Typography style={{ fontWeight: 600 }}>{price}</Typography>
        </Box>
        <Typography align={'right'} color={'textSecondary'}>
          Behandlungsgebühr
        </Typography>
      </>
    );
  } else {
    return (
      <>
        <Typography style={{ fontWeight: 600 }}>Erstattungsfähig</Typography>
        <Typography align={'right'} color={'textSecondary'}>
          Behandlungsgebühr
        </Typography>
      </>
    );
  }
};

const MedicationInfo = (provider: MedicationInfoProps): React.ReactElement => {
  const classes = useStyles();

  return (
    <div>
      <Box display="flex" flex="1" flexDirection="row" className="u-padding--top">
        <Box flexGrow={1}>
          <Typography style={{ fontWeight: 600 }}>{provider.name}</Typography>
          <Feature featureName={Features.providerPageWording} renderIfDisabled>
            <Typography color={'textSecondary'}>Ihre Online-Arztpraxis *</Typography>
          </Feature>
        </Box>
        {provider.area !== Area.TREATMENT_NOW && <Box className={classes.priceColumn}>{priceColumn(provider)}</Box>}
      </Box>
    </div>
  );
};

export { MedicationInfo };
